<template>
  <m-pay-layout>
    <v-layout :column="$vuetify.breakpoint.smAndDown">

      <m-pay-confirm-dialog
        :show="showConfirmationDialog"
        :title="confirmationDialog.description"
        @yes="confirmationDialog.action"
        @cancel="hideDialog"
        maxWidth="700px"
      />

      <v-flex class="mb-3 mx-2">
        <v-card>
          <v-card-title>
            <span class="headline">Merchant Certificate Details</span>
          </v-card-title>
          <v-card-text>
            <v-text-field label="Key Name"
                          readonly
                          :value="merchantCertificate.name"
            ></v-text-field>
            <v-text-field label="Created At"
                          readonly
                          :value="formatDateTime(merchantCertificate.createdDate)"
            ></v-text-field>
            <v-text-field label="Created By"
                          readonly
                          :value="merchantCertificate.createdBy"
            ></v-text-field>
            <v-text-field label="Expiration date"
                          readonly
                          :value="formatDate(merchantCertificate.expirationDate)"
            ></v-text-field>
            <v-textarea label="Public key"
                        readonly rows="10"
                        :value="merchantCertificate.publicKey"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="merchantCertificate.id" flat color="secondary"
                   v-clipboard="merchantCertificate.publicKey">
              Copy Public Key
            </v-btn>
            <v-btn v-if="merchantCertificate.id" flat color="secondary"
                   :loading="loadingDis"
                   :disabled="loadingDis"
                   @click.native="confirmAndDisableCertificate">
              Disable certificate
            </v-btn>
            <v-btn flat color="secondary"
                   @click.native="cancel">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

    </v-layout>
  </m-pay-layout>
</template>

<script>
import axios from 'axios';
import formatters from '../../utils/formatters';
import queries from '../../utils/queries';
import MPayErrorMessage from '../MPayErrorMessage';
import MPayCopyButton from '../MPayCopyButton';
import MPayConfirmDialog from '../MPayConfirmDialog';

export default {
  name: 'MPayMerchantCertificateDetailsView',
  components: { MPayCopyButton, MPayErrorMessage, MPayConfirmDialog },
  data: () => ({
    loading: false,
    loadingDis: false,
    merchantCertificate: {},
    showConfirmationDialog: false,
    confirmationDialog: {
      title: '',
      description: '',
      action: {},
    },
    disableRequest: {
      id: null,
    },
    merchantCertificateId: null,
  }),
  methods: {
    fetchCertificateInfo() {
      this.loading = true;
      axios.get(queries.userMerchantCertificateById(this.merchantCertificateId))
        .then((response) => {
          this.merchantCertificate = response.data;
          this.loading = false;
        })
        .catch((e) => {
          this.showError(e);
          this.loading = false;
        });
    },
    confirmAndDisableCertificate() {
      this.showDialog('This will invalidate current connection configuration ' +
        'and disable certificate. Are you sure?', this.disableCertificate);
    },
    disableCertificate() {
      this.loadingDis = true;
      this.disableRequest.id = this.merchantCertificate.id;

      axios.put(queries.disableMerchantCertificate(), this.disableRequest)
        .then(() => {
          this.showSuccessMessage('Certificate disabled.');
          this.$router.push({ name: 'certs' });
        })
        .catch((e) => {
          this.showError(e);
        })
        .finally(() => {
          this.loadingDis = false;
          this.hideDialog();
        });
    },
    formatDate(timestamp) {
      return formatters.date(timestamp);
    },
    formatDateTime(timestamp) {
      return formatters.dateTime(timestamp);
    },
    showDialog(message, onSuccessCallback) {
      this.showConfirmationDialog = true;
      this.confirmationDialog = {
        title: '',
        description: message,
        action: onSuccessCallback,
      };
    },
    hideDialog() {
      this.showConfirmationDialog = false;
    },
    saveData(data, fileName, contentType) {
      const a = document.createElement('a');
      a.style = 'display: none';
      document.body.appendChild(a);

      const blob = new Blob([data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    cancel() {
      this.$router.push({ name: 'certs' });
    },
  },
  computed: {
    certificateId() {
      return this.$route.query.certificateId;
    },
  },
  created() {
    if (this.$route.params.certificateId) {
      this.merchantCertificateId = this.$route.params.certificateId;
      this.fetchCertificateInfo();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantCertificateDetailsView.vue